import { readCachedOrgFlag, useCachedOrgFlag } from "./useCachedOrgFlag";
const STORAGE_KEY_PREFIX = "codesmith-automations-enabled:";
export function readCachedAutomationsEnabled(orgName: string | null): boolean {
  return readCachedOrgFlag(STORAGE_KEY_PREFIX, orgName);
}

/**
 * Cached codesmith automations flag for the session sidebar's Automations
 * nav row. Worst case the row links an org whose flag was just turned off;
 * the automations pages redirect home.
 */
export function useCachedAutomationsEnabled(args) {
  return useCachedOrgFlag(STORAGE_KEY_PREFIX, args);
}